import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import Select from 'react-select';
import { LuMessageCircle } from "react-icons/lu";
import { initiateWhatsApp } from '../../redux/reducers/communicationSlice';
import { getCustomersByBusiness } from '../../redux/reducers/customerSlice';
import { formatPhoneNumber } from '../../utils/phoneUtils';


const WhatsAppInitiateModal = ({ show, onHide }) => {
  const dispatch = useDispatch();
  const { customerList } = useSelector((state) => state.customer);
  const { sendingMessage } = useSelector((state) => state.communication);
  const selectedBusiness = useSelector((state) => state.business.selectedBusiness);
  const businessId = selectedBusiness?._id;
  const businessName = selectedBusiness?.name || "Our Business";

  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (show && businessId) {
      dispatch(getCustomersByBusiness(businessId));
    }
  }, [show, businessId, dispatch]);

  useEffect(() => {
    if (selectedCustomer) {
      const name = selectedCustomer.label.split(' (')[0];
      setMessage(`Hi ${name}, I'm reaching out from ${businessName}...`);
    }
  }, [selectedCustomer, businessName]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedCustomer) return;

    dispatch(initiateWhatsApp({
      businessId,
      customerId: selectedCustomer.value,
      message
    })).then((res) => {
      if (!res.error && res.payload.waLink) {
        window.open(res.payload.waLink, '_blank');
        onHide();
        setSelectedCustomer(null);
        setMessage('');
      }
    });
  };

  const customerOptions = customerList
    .filter(c => (c.phone?.number) || (c.communicationPreferences?.whatsappNumber?.number))
    .map(c => ({
      value: c._id,
      label: `${c.name || 'No Name'} (${c.email})`,
      phone: c.communicationPreferences?.whatsappNumber?.number 
        ? c.communicationPreferences.whatsappNumber 
        : c.phone
    }));

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold" style={{ fontSize: '18px' }}>Start WhatsApp Conversation</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Customer*</Form.Label>
            <Select
              options={customerOptions}
              value={selectedCustomer}
              onChange={setSelectedCustomer}
              placeholder="Search customers with phone..."
            />
          </Form.Group>

          {selectedCustomer && (
            <Form.Group className="mb-3">
              <Form.Label className="small fw-semibold">WhatsApp Number</Form.Label>
              <Form.Control
                type="text"
                value={formatPhoneNumber(selectedCustomer.phone)}
                readOnly
                disabled
                style={{ borderRadius: '8px', background: '#f8fafc' }}
              />
            </Form.Group>
          )}

          <Form.Group className="mb-3">
            <Form.Label className="small fw-semibold">Opening Message (optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type your message..."
              style={{ borderRadius: '8px' }}
            />
          </Form.Group>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="light" onClick={onHide} className="rounded-3 px-4 fw-semibold">
              Cancel
            </Button>
            <Button 
              type="submit" 
              className="rounded-3 px-4 fw-semibold d-flex align-items-center gap-2"
              style={{ background: '#10b981', border: 'none', color: 'white' }}
              disabled={sendingMessage || !selectedCustomer}
            >
              {sendingMessage ? <Spinner size="sm" /> : <LuMessageCircle size={16} />}
              Open WhatsApp
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default WhatsAppInitiateModal;
